export default __webpack_public_path__ + "static/media/logo.93b0c285.png";